module.exports = __webpack_public_path__ + "img/icon38.f77e0229.png";